<template>
  <div class="body">
    <div class="popup">
      <div class="t-c">用户登录</div>
      <van-field v-model="iccid" name="mobile" label="" placeholder="请输入你要激活的号码"
        :rules="[{ required: true, message: '请输入你要激活的号码' }]" />
      <van-button class="bu_tn" round block type="info" native-type="submit" @click="onSubmit">立即登录</van-button>
      <!-- <van-button class="bu_tn1" round block type="info" native-type="submit">激活视频</van-button> -->
    </div>
    <!-- <div class="zxkf" style="">
      <img src="@/assets/img/kf.png" style="width:26px;height: 26px;margin-top:4px;">
      <div class="zxkf-btn" >在线客服</div>
    </div> -->



  </div>
</template>

<script>
import { Dialog } from "vant";
import { Toast } from "vant";
import { wxRequest } from "@/api/user.js";
import SeAutocomplete from "@/components/SeAutocomplete";
import Advertisement from "@/components/Advertisement";
export default {
  data() {
    return {
      code: "",
      iccid: "",
    };
  },
  async created() {
    var source = this.getQueryVariable("source")
      ? this.getQueryVariable("source")
      : process.env.VUE_APP_APPID;
    localStorage.setItem("isHeadquarterAppid", true);
    var appid = source ? source : process.env.VUE_APP_APPID;
    //获取总部公众号appid
    await wxRequest("/sim/appId", {}, "post").then((res) => {
      if (res.data.code == 200) {

        appid = res.data.data.collectAppid;
      }
    });
    this.$store.commit("setIsHeadquarterAppid", "true");
    localStorage.setItem("isHeadquarterAppid", true);
    localStorage.setItem("appid", source);
    console.log(appid);

    //先查询是否是乐刷支付 如果是乐刷支付 就不用授权了
    await wxRequest(
      "sim/get/pay/state",
      {
        iccid: localStorage.getItem("iccid"),
      },
      "post"
    ).then((res) => {
      localStorage.setItem("payCode", res.data.code);
      if (res.data.code == 200) {
        localStorage.setItem("leshuaPay", 1);
        this.code = "leshua";
        this.iccid = localStorage.getItem("recordLoginText");
      } else {
        var redirectUrl = window.location.href;
        var index = redirectUrl.indexOf("code");
        redirectUrl = encodeURIComponent(redirectUrl);
        localStorage.setItem("leshuaPay", 2);
        if (index < 0) {
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
        } else {
          var search = window.location.search;
          console.log("search", search);
          var startIndex = search.indexOf("code");
          var endIndex = search.indexOf("&", startIndex);
          var str = search.slice(startIndex, endIndex);
          var code = str.slice(str.indexOf("=") + 1);
          this.code = code;
          this.iccid = localStorage.getItem("recordLoginText");
        }
      }
    });
  },
  methods: {
    // 客服跳转
    kflink() {
      window.location.href = 'https://work.weixin.qq.com/kfid/kfc19ef34f8410b8a29'
    },
    //获取url参数
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
    onSubmit() {
      let recordLoginText = this.iccid;
      let data = {
        requestId: this.iccid,
        code: this.code,
      };
      wxRequest("sim/bind", data, "get").then((res) => {
        if (res.data.code == 200) {
          let record = res.data.data;
          let iccid = record.iccid;
          this.$store.state.isNewPage = 0;
          localStorage.setItem("isNewPage", 0);
          localStorage.setItem("isMyLogin", 0);

          localStorage.setItem("bindPhone", record.bindPhone);
          localStorage.setItem("titleUrl", record.titleUrl);
          localStorage.setItem("titleImg", record.titleImg);
          localStorage.setItem("isTitle", record.isTitle);


          localStorage.setItem("isCode", true);
          localStorage.setItem("mobile", record.mobile);
          localStorage.setItem("supplierTypeName", record.supplierTypeName);
          localStorage.setItem("wxHeadImg", record.wxHeadImg);
          localStorage.setItem("wxNickName", record.wxNickName);
          localStorage.setItem("shebeiLogin", 0);
          localStorage.setItem("recordLoginText", recordLoginText);
          localStorage.setItem("supplierName", record.supplierName);
          localStorage.setItem("intoNo", record.intoNo);
          localStorage.setItem("isSale", record.isSale);
          localStorage.setItem("yucun", record.yucun);
          localStorage.setItem("kefuUrl", record.kefuUrl);
          localStorage.setItem("priceImgUrl", record.priceImgUrl);
          localStorage.setItem("ishavePkg", record.ishavePkg);
          localStorage.setItem("isSale", record.isSale);
          localStorage.setItem("salePrice", record.salePrice);
          localStorage.setItem("ishavePrice", record.ishavePrice);
          sessionStorage.setItem("isLine", true);
          localStorage.setItem("flowRatePool", record.flowRatePool);
          this.$store.state.flowRatePool = res.data.data.flowRatePool;
          localStorage.setItem("iccid", record.iccid);
          localStorage.setItem("openId", record.openId);
          localStorage.setItem("virtualNo", record.virtualNo);

          localStorage.setItem("userPhone", record.userPhone);
          this.$store.state.userPhone = record.userPhone;

          this.$store.state.recordLoginText = recordLoginText;
          this.$store.state.supplierCode = res.data.data.supplierCode;
          this.$store.state.iccid = iccid;
          this.$store.commit("setIccid", iccid);

          this.$store.state.intoNo = record.intoNo;
          sessionStorage.setItem("intoNo", record.intoNo);
          //未实名的电信卡用户（通过cardType字段判断），实名认证时将只需要绑定
          let cardType = record.supplierTypeCode;
          let _data = {
            requestId: iccid,
            code: this.code,
          };
          if (record.bindPhone == 2) {
            if (record.newBind == 1) {
              this.$router.push({
                path: "/user/bindPhoneAuth",
                query: {
                  iccid: record.iccid,
                },
              });
            } else {
              this.$router.push({
                path: "/user/bindPhoneOnely",
                query: {
                  iccid: record.iccid,
                },
              });
            }
          } else if ((record.isSale == 1 || record.isSale == 3) && record.ishavePrice == 0) {
            this.$router.replace("/user/simOpens");
          } else if (record.isSale > 0 && record.ishavePrice == 0) {
            this.$router.replace("/user/simOpens");
          } else {
            if ((record.bindPhone == 0) || (record.bindPhone == 1 && record.ishavePkg == 0)) {
              localStorage.setItem("phoneNo", record.userPhone);
              this.$router.replace("/user/home");
            } else {
              if (record.newBind == 1) {
                this.$router.push({
                  path: "/user/bindPhoneAuth",
                  query: {
                    iccid: record.iccid,
                  },
                });
              } else {
                this.$router.push({
                  path: "/user/bindPhoneOnely",
                  query: {
                    iccid: record.iccid,
                  },
                });
              }
            }
          }
        } else {
          Dialog.alert({ title: "提示", message: res.data.message });
        }
      });
    },
  },
};
</script>


<style lang="less" scoped>
.more-dialog {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10001;

  .more-bg {
    background: rgba(0, 0, 0, .3);
    width: 100%;
    height: 100%;
  }

  .more-list {
    width: 90%;
    height: 400px;
    background: #fff;
    border-radius: 10px;
    position: absolute;
    top: 0;
    left: 0;
    margin: auto;
    bottom: 0;
    right: 0;

    .more-title {
      text-align: center;
      font-size: 19px;
      border-radius: 14px;
      font-weight: 600;
      color: #222222;
      height: 51px;
      padding-top: 22px;
      background: linear-gradient(180deg, #DAE8FF 0%, rgba(255, 255, 255, 0) 100%);
    }

    .more-list-flex {
      overflow: auto;
      height: 220px;
    }

    .more-list-item {
      display: flex;
      height: 60px;
      width: 85%;
      margin: 0 auto 8px;
      border: 1px solid #EEF4FF;
      align-items: center;

      img {
        width: 65px;
        height: 18px;
        margin-left: 10px;
        margin-right: 20px;
      }

      .num {
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #94959A;
        line-height: 20px;
      }
    }

    .active {
      border: 1px solid #1772FF;
    }

    .dialog-btn {
      display: flex;
      position: absolute;
      bottom: 18px;
      width: 100%;
      height: 40px;
      justify-content: space-around;

      .close {
        width: 121px;
        height: 44px;
        background: #F5F5F5;
        border-radius: 7px;
        font-size: 15px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        text-align: center;
        line-height: 44px;
      }

      .corm {
        width: 121px;
        height: 44px;
        background: linear-gradient(90deg, #50A9FF 0%, #1772FF 100%);
        border-radius: 7px;
        font-size: 15px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #fff;
        text-align: center;
        line-height: 44px;
      }
    }
  }

}

.body {
  .more-dialog {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 10001;

    .more-bg {
      background: rgba(0, 0, 0, .3);
      width: 100%;
      height: 100%;
    }

    .more-list {
      width: 90%;
      height: 400px;
      background: #fff;
      border-radius: 10px;
      position: absolute;
      top: 0;
      left: 0;
      margin: auto;
      bottom: 0;
      right: 0;

      .more-title {
        text-align: center;
        font-size: 19px;
        border-radius: 14px;
        font-weight: 600;
        color: #222222;
        height: 51px;
        padding-top: 22px;
        background: linear-gradient(180deg, #DAE8FF 0%, rgba(255, 255, 255, 0) 100%);
      }

      .more-list-flex {
        overflow: auto;
        height: 220px;
      }

      .more-list-item {
        display: flex;
        height: 60px;
        width: 85%;
        margin: 0 auto 8px;
        border: 1px solid #EEF4FF;
        align-items: center;

        img {
          width: 65px;
          height: 18px;
          margin-left: 10px;
          margin-right: 20px;
        }

        .num {
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #94959A;
          line-height: 20px;
        }
      }

      .active {
        border: 1px solid #1772FF;
      }

      .dialog-btn {
        display: flex;
        position: absolute;
        bottom: 18px;
        width: 100%;
        height: 40px;
        justify-content: space-around;

        .close {
          width: 121px;
          height: 44px;
          background: #F5F5F5;
          border-radius: 7px;
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          text-align: center;
          line-height: 44px;
        }

        .corm {
          width: 121px;
          height: 44px;
          background: linear-gradient(90deg, #50A9FF 0%, #1772FF 100%);
          border-radius: 7px;
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #fff;
          text-align: center;
          line-height: 44px;
        }
      }
    }

  }

  background:#fff url("../../assets/lgbj.png") no-repeat;
  background-size: 100%;
  width: 100%;
  height: 100%;
  position: relative;

  .popup {
    .t-c {
      text-align: center;
      padding-top: 300px;
      font-size: 24px;
      font-weight: bold;
    }

    .van-cell {
      height: 50px;
      width: 60%;
      border-radius: 30px;
      border: 1px solid #ddd;
      padding-left: 10px;
      padding: 0;
      background: none;
      margin: auto;
      text-align: center;
      margin-top: 20px;
      line-height: 48px;

      ::v-deep .van-cell__title {
        width: 0;
      }

      ::v-deep .van-cell__value {
        line-height: 48px;

        .van-field__body {
          .van-field__control {
            line-height: 48px;
            height: 48px;
            text-align: center;
          }
        }
      }
    }

    .bu_tn {
      height: 50px;
      line-height: 50px;
      text-align: center;
      width: 60%;
      color: #fff;
      background: #f7691a;
      border-radius: 30px;
      margin: auto;
      margin-top: 20px;
      border: 1px solid #f7691a;
    }

    .bu_tn1 {
      height: 32px;
      line-height: 32px;
      text-align: center;
      width: 30%;
      color: #f7691a;
      background: #fff;
      border-radius: 30px;
      margin: auto;
      margin-top: 20px;
      border: 1px solid #f7691a;
    }
  }

  .zxkf {
    width: 30px;
    height: 100px;
    position: fixed;
    border-radius: 25px;
    right: 6px;
    bottom: 180px;
    text-align: center;
    background: #FF9866;

    .zxkf-btn {
      font-size: 14px;
      color: #fff;
      line-height: 15px;
      margin: 0 8px;
      margin-top: -2px;
    }
  }
}
</style>